export const getPageList = (totalPages, currentPage, limit) => {
  if (limit < 5) {
    return;
  }

  function range(start, end) {
    return Array.from(Array(end - start + 1), (_, i) => i + start);
  }

  var sideWidth = limit < 9 ? 1 : 2;
  var leftWidth = (limit - sideWidth * 2 - 3) >> 1;
  var rightWidth = (limit - sideWidth * 2 - 2) >> 1;
  if (totalPages <= limit) {
    // no breaks in list
    return range(1, totalPages);
  }
  if (currentPage <= limit - sideWidth - 1 - rightWidth) {
    // no break on left of currentPage
    return range(1, limit - sideWidth - 1).concat(
      0,
      range(totalPages - sideWidth + 1, totalPages)
    );
  }
  if (currentPage >= totalPages - sideWidth - 1 - rightWidth) {
    // no break on right of currentPage
    return range(1, sideWidth).concat(
      0,
      range(totalPages - sideWidth - 1 - rightWidth - leftWidth, totalPages)
    );
  }
  // Breaks on both sides
  return range(1, sideWidth).concat(
    0,
    range(currentPage - leftWidth, currentPage + rightWidth),
    0,
    range(totalPages - sideWidth + 1, totalPages)
  );
};
